/**
 * @file Surcharges du CssBaseline MUI appliquées à l'ensemble des applications.
 * @module packages.common.theme.overrides.components.css-baseline
 *
 * Ces règles sont injectées via le `Global` d'Emotion, dont la balise `style` est
 * ajoutée en fin de `head` : elles l'emportent donc sur les feuilles inline des
 * `index.html`, à spécificité égale. Toute valeur posée ici doit être pensée comme
 * la valeur effective, et non comme un défaut surchargeable par les applications.
 */

// ----------------------------------------------------------------------

export function cssBaseline(theme) {
  return {
    MuiCssBaseline: {
      styleOverrides: {
        '*': {
          boxSizing: 'border-box',
        },
        // La hauteur de `html` doit rester un pourcentage. Une hauteur issue d'un
        // mot-clé tel que `-webkit-fill-available` n'est pas une hauteur définie au
        // sens de la résolution des pourcentages descendants : WebKit fait alors
        // retomber `body` puis `#root` en `auto`, et toute la chaîne s'effondre.
        'html': {
          margin: 0,
          padding: 0,
          width: '100%',
          height: '100%',
          WebkitOverflowScrolling: 'touch',
        },
        // Le repli `-webkit-fill-available` compense la barre d'URL d'iOS. Il se
        // déclare en tableau : deux clés identiques dans un objet JavaScript se
        // recouvrent silencieusement, ce qui supprimerait la valeur de repli.
        'body': {
          margin: 0,
          padding: 0,
          width: '100%',
          minHeight: ['100%', '-webkit-fill-available'],
        },
        '#root, #__next': {
          width: '100%',
          height: '100%',
        },
        'input': {
          '&[type=number]': {
            'MozAppearance': 'textfield',
            '&::-webkit-outer-spin-button': {
              margin: 0,
              WebkitAppearance: 'none',
            },
            '&::-webkit-inner-spin-button': {
              margin: 0,
              WebkitAppearance: 'none',
            },
          },
        },
        'img': {
          maxWidth: '100%',
          display: 'inline-block',
          verticalAlign: 'bottom',
        },
      },
    },
  };
}
